import i18n from "@/language/i18n";
import PROJECT_MANAGEMENT_WIDGETS from "@/configuration/widgets/PROJECT_MANAGEMENT_WIDGETS";

const PROJECT_MANAGEMENT_MODULE_WINDOW_IDENTIFIER = Object.freeze({
    PROJECTS_MODULE_WINDOW_ID: 'projects',
    INQUIRIES_MODULE_WINDOW_ID: 'inquiries',
    TEMPLATE_MODULE_WINDOW_ID: 'categoryTree'
});

export { PROJECT_MANAGEMENT_MODULE_WINDOW_IDENTIFIER };

export default {
    PROJECT_MANAGMENT_GROUP_WRAPPER: {
        type: 'group',
        id: 'projectManagement',
        label: i18n.t('ModuleRegistry.groups.projectManagement.name'),
        children: [],
        icon: '$wPlanning',
        sidebarIcon: '$wNavProjectManagment'
    },
    CHILDREN: {
        PROJECTS_MODULE: {
            type: 'module',
            id: 'projectsOverview',
            windowIdentifierType: PROJECT_MANAGEMENT_MODULE_WINDOW_IDENTIFIER.PROJECTS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.projectManagement.projectsOverview.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/projects',
            globalSearch: {
                index: 'projects',
                presentation: i18n.t('ModuleRegistry.groups.projectManagement.projectsOverview.presentation'),
                component: 'ProjectItem',
                shortcut: '-p'
            },
            widgets: PROJECT_MANAGEMENT_WIDGETS.PROJECT_WIDGETS
        },
        INQUIRIES_MODULE: {
            type: 'module',
            id: 'projectInquiries',
            windowIdentifierType: PROJECT_MANAGEMENT_MODULE_WINDOW_IDENTIFIER.INQUIRIES_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.projectManagement.projectInquiries.label'),
            navigationImg: require('@/assets/navigation/items/icon_projectanfragen.svg'),
            routerLink: '/inquiries',
            globalSearch: {
                index: "inquiries",
                presentation: i18n.t('ModuleRegistry.groups.projectManagement.projectInquiries.label'),
                component: "InquiryItem.vue",
                shortcut: "-i"
            },
            widgets: PROJECT_MANAGEMENT_WIDGETS.INQUIRY_WIDGETS
        },
        TEMPLATE_MODULE: {
            type: 'module',
            id: 'projectsCategoryTree',
            windowIdentifierType: PROJECT_MANAGEMENT_MODULE_WINDOW_IDENTIFIER.TEMPLATE_MODULE_WINDOW_ID,
            label: i18n.t('CategoryTrees.words.categoryTrees'),
            navigationImg: require('@/assets/navigation/items/icon_projectanfragen.svg'),
            routerLink: '/projects-categorytree',
            globalSearch: {
                index: 'preview',
                presentation: i18n.t('CategoryTrees.words.categoryTrees'),
                component: 'TemplateItem',
            },
        },
        PROJECT_PROGRESS_MODULE: {
            type: 'module',
            id: 'projectprogress',
            label: "Projektfortschritt",
            navigationImg: require('@/assets/navigation/items/icon_projectanfragen.svg'),
            routerLink: '/projectprogress',
        }
    }
}